import { render, staticRenderFns } from "./mvp-authentication.vue?vue&type=template&id=0d724ebc&scoped=true&"
import script from "./mvp-authentication.vue?vue&type=script&lang=js&"
export * from "./mvp-authentication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d724ebc",
  null
  
)

export default component.exports